import React from 'react';
import MotionContainer from '../components/Motion/MotionContainer';
import Section from '../components/Section/Section';
import WorkContent from '../components/WorkContent/WorkContent';

const Works = () => {
  return (
    <MotionContainer>
      <Section title="Works">
        <WorkContent />
      </Section>
    </MotionContainer>
  );
};

export default Works;
